<template>
    <div v-if="this.order.getFirstEvent()">
        <div class="order-date">
            {{
                this.app.mixins.MixinVue.methods.vue.methods.dateDayFullText(
                    order.getFirstEvent().start_datetime,
                    order.getFirstEvent().timezone,
                    order.course.is_online
                )
            }}
            {{
                this.app.mixins.MixinVue.methods.vue.methods.dateDayNumber(
                    order.getFirstEvent().start_datetime,
                    order.getFirstEvent().timezone,
                    order.course.is_online
                )
            }}
            {{
                this.app.mixins.MixinVue.methods.vue.methods.dateMonthAndYear(
                    order.getFirstEvent().start_datetime,
                    order.getFirstEvent().timezone,
                    order.course.is_online
                )
            }}
        </div>
        <div class="course-hours">
            <span
                v-html="
                    this.app.mixins.MixinVue.methods.vue.methods.hours(
                        order.getFirstEvent().start_datetime,
                        order.getFirstEvent().end_datetime,
                        order.getFirstEvent().timezone,
                        order.course.is_online
                    )
                "
            ></span>
            <span class="course-timezone" v-if="order.course.is_online"
                >({{ this.app.locale.getUserTimezone() }})</span
            >
        </div>
    </div>
</template>

<script>
import CourseOrder from './../../../../../class/CourseOrder';

export default {
    props: {
        order: {
            type: CourseOrder,
            required: true,
        },
    },
};
</script>
